"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextMenuDisplayFormatter = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var Icons_1 = require("../../icons/Icons");
var PreventUserSelect_1 = require("../../styles/PreventUserSelect");
var TabStyles_1 = require("../../styles/TabStyles");
var TextEllipsis_1 = require("../../styles/TextEllipsis");
var Declarative_1 = require("../../utils/Declarative");
var DomUtil_1 = require("../../utils/DomUtil");
var DomWidgets_1 = require("../DomWidgets");
var ListStyles_1 = require("../List/ListStyles");
var Sizing = TabStyles_1.TabStyles.Sizing, Colors = TabStyles_1.TabStyles.Colors, Spacing = TabStyles_1.TabStyles.Spacing, Typography = TabStyles_1.TabStyles.Typography;
var getStyles = function () {
    return {
        MenuItem: tslib_1.__assign(tslib_1.__assign({ height: Sizing.ListRowHeight, paddingLeft: Spacing.DefaultSpace, paddingRight: Spacing.DefaultSpace, lineHeight: Sizing.ListRowHeight + 'px', position: 'relative' }, TextEllipsis_1.TextEllipsis), PreventUserSelect_1.PreventUserSelect),
        GroupLabel: tslib_1.__assign(tslib_1.__assign({ fontWeight: 'bold', height: TabStyles_1.TabStyles.Sizing.ListRowHeight, lineHeight: TabStyles_1.TabStyles.Sizing.ListRowHeight + 'px' }, TextEllipsis_1.TextEllipsis), PreventUserSelect_1.PreventUserSelect),
        Highlighted: {
            backgroundColor: Colors.F2
        },
        Active: {
            backgroundColor: Colors.F3
        },
        WithCheckGutter: {
            paddingLeft: Icons_1.MenuItemCheckIcon.checkedItemPaddingLeft
        },
        WithSubMenu: {
            paddingRight: Icons_1.MenuItemArrowIcon.width
        },
        Disabled: {
            color: Typography.Color.Disabled
        },
        ArrowIcon: {
            position: 'absolute',
            right: 0
        }
    };
};
/**
 * Using closure the formatter has access to the text value that it wants to display, and gets its other props
 * from the dropdown. This will be rendered in the MenuItemWidget.
 *
 * @param displayValue The text value to be displayed
 */
exports.TextMenuDisplayFormatter = function (displayValue, title) {
    return /** @class */ (function (_super) {
        tslib_1.__extends(TextFormatterWidget, _super);
        function TextFormatterWidget(props) {
            var _this = _super.call(this, props) || this;
            _this.handleMouseOver = function (e) {
                if (title) {
                    // NOTE: The custom title will override the default title when the displayed value within the menu item is truncated.
                    return;
                }
                _this.setState({ title: (DomUtil_1.isElementOverflownX(e.currentTarget)) ? displayValue : undefined });
            };
            _this.state = { title: title };
            return _this;
        }
        TextFormatterWidget.prototype.getSubMenuIcon = function () {
            if (this.props.hasSubMenu) {
                var styles = getStyles();
                var arrowIcon = Icons_1.MenuItemArrowIcon.icon({ disabled: this.props.disabled });
                return React.createElement(DomWidgets_1.Img, { style: styles.ArrowIcon, src: arrowIcon, "aria-hidden": true });
            }
            else {
                return null;
            }
        };
        TextFormatterWidget.prototype.render = function () {
            var styles = getStyles();
            var style = this.props.isGroupLabel ? styles.GroupLabel : tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, styles.MenuItem), Declarative_1.conditional(this.props.hasSubMenu, styles.WithSubMenu)), Declarative_1.conditional(this.props.isHighlighted, styles.Highlighted)), Declarative_1.conditional(this.props.active, styles.Active)), Declarative_1.conditional(this.props.disabled, styles.Disabled)), Declarative_1.conditional(this.props.showCheckGutter, styles.WithCheckGutter)), Declarative_1.conditional(this.props.checked, ListStyles_1.MenuItemCheckStyles({
                active: this.props.active || this.props.isHighlighted,
                disabled: this.props.disabled,
            })));
            return (React.createElement("div", { "data-tb-test-id": Declarative_1.makeTestId(this.props.testId, 'TextMenuItem'), onMouseOver: this.handleMouseOver, style: style, title: this.state.title },
                displayValue,
                this.getSubMenuIcon()));
        };
        return TextFormatterWidget;
    }(React.Component));
};
//# sourceMappingURL=TextMenuDisplayFormatter.js.map